import { bothDirectionsSortOptions } from '../constants';
import type { TranslateFunc } from 'src/components/translate';
import type { SortInfo } from 'src/types';

export const getDropdownSortSelected = (
  sort: SortInfo | undefined | null,
  t: TranslateFunc
) => {
  return sort?.name && sort.name.indexOf('property:') !== 0
    ? t(
        'common',
        `sort.${sort.name as SortKey}${
          bothDirectionsSortOptions.includes(sort.name as SortKey)
            ? (`:${sort.direction}` as SortDirection)
            : ''
        }`
      )
    : '';
};

type SortKey = typeof bothDirectionsSortOptions[number];
type SortDirection = ':asc' | ':desc';
